import { createSlice } from "@reduxjs/toolkit";
import { clearFilter, closeDownloadModal, closeUploadModal, createPack, getDownloadPack, getDownloadPackdetails, getEmailfromSession, getPicklist, openDownloadModal, openUploadModal, resetFilter, resetUploadProgress, setSearchKeyword, updateFilterValues, updateUploadCancelToken, updateUploadProgress } from "./TranscribeAction";
import { CancelToken, CancelTokenSource } from "axios";

interface GetDownloadDataState {
  data: any;
  loading: boolean;
  id: number;
  id_pack: number;
  date_created: string;
  status: string;
  created_by: string;
  template: string;
  fileDownloadLoading: boolean;
  s3_location: string;
}
export interface FilterValueType {
  PackPriorityId: number;
  StatusId: number;
  TenantId: number;
  TranscriptionTypeId: number;
  packId: number;
}
export interface FileUpload {
  uploadProgress: number;
  cancelUploadToken: CancelTokenSource | null;
  status: "normal" | "exception" | "active" | "success";
  fileName: string;
  fileExtension: string;
  // file: File;
  error: string | null;
}
const currentFileUpload: FileUpload = {
  uploadProgress: 0,
  cancelUploadToken: null,
  status: "normal",
  fileName: "",
  error: null,
  fileExtension: "",
};

interface OptionType {
  label: string;
  value: any;
}
export interface PickListType {
  tenantPicklist: OptionType[];
  priorityPicklist: OptionType[];
  transcriptionPicklist: OptionType[];
  statusPicklist: OptionType[];
}

interface TranscribeStateType {
  //Upload
  uploadModalState: boolean;
  //Download
  downloadModalState: boolean;
  downloadLoading: boolean;
  //Getting Email from Current User Payload
  email: string;
  searchKeyword: string;
  error: string | undefined;
  currentFileUpload: FileUpload;
  getDownloadDataState: GetDownloadDataState;
  filterValues: FilterValueType;
  pickList: PickListType;
  pickListLoading: boolean;
  createPackLoading: boolean;
}
const TranscribeInitialState: TranscribeStateType = {
  //Upload
  uploadModalState: false,
  //Download
  downloadModalState: false,
  downloadLoading: false,
  currentFileUpload: currentFileUpload,
  createPackLoading: false,

  //Getting Email from Current User Payload
  email: "",
  error: undefined,
  searchKeyword: "",
  getDownloadDataState: {
    data: [],
    loading: false,
    id: 0,
    id_pack: 0,
    date_created: "",
    status: "",
    created_by: "",
    template: "",
    s3_location: "",
    fileDownloadLoading: false,
  },
  filterValues: {
    PackPriorityId: 0,
    StatusId: 0,
    TenantId: 0,
    TranscriptionTypeId: 0,
    packId: 0,
  },
  pickList: {
    tenantPicklist: [],
    priorityPicklist: [],
    transcriptionPicklist: [],
    statusPicklist: [],
  },
  pickListLoading: false,
};
const TranscribeSlice = createSlice({
  initialState: TranscribeInitialState,
  name: "transcribe",
  reducers: {},
  extraReducers(builder) {
    builder
      //Upload
      .addCase(openUploadModal, (state, action) => {
        state.uploadModalState = true;
      })

      .addCase(closeUploadModal, (state, action) => {
        state.uploadModalState = false;
      })

      //Download
      .addCase(openDownloadModal, (state, action) => {
        state.downloadModalState = true;
      })

      .addCase(closeDownloadModal, (state, action) => {
        state.downloadModalState = false;
      })

      //Get email from Payload Current user
      .addCase(getEmailfromSession, (state, action) => {
        state.email = action.payload;
      })

      //Get download data of each pack
      .addCase(getDownloadPackdetails.pending, (state, action) => {
        state.getDownloadDataState.loading = true;
      })
      .addCase(getDownloadPackdetails.fulfilled, (state, action) => {
        state.getDownloadDataState.data = action.payload;
        state.getDownloadDataState.loading = false;
      })
      .addCase(getDownloadPackdetails.rejected, (state, action) => {
        state.error = action.error.message;
        state.getDownloadDataState.loading = false;
      })
      .addCase(updateFilterValues, (state, action) => {
        state.filterValues = action.payload;
      })

      .addCase(getPicklist.pending, (state, action) => {
        state.pickListLoading = true;
      })
      .addCase(getPicklist.fulfilled, (state, action) => {
        state.pickList = action.payload;
        state.pickListLoading = false;
      })
      .addCase(getPicklist.rejected, (state, action) => {
        state.error = action.error.message;
        state.pickListLoading = false;
      })

      .addCase(clearFilter, (state, action) => {
        state.filterValues = TranscribeInitialState.filterValues;
      })
      .addCase(setSearchKeyword, (state, action) => {
        state.searchKeyword = action.payload;
      })
      .addCase(updateUploadCancelToken, (state, action) => {
        state.currentFileUpload.cancelUploadToken = action.payload.cancelToken;
      })
      .addCase(createPack.pending, (state, action) => {
        state.createPackLoading = true;
      })
      .addCase(createPack.fulfilled, (state, action) => {
        state.createPackLoading = false;
      })
      .addCase(createPack.rejected, (state, action) => {
        state.error = action.error.message;
        state.createPackLoading = false;
      })

      .addCase(updateUploadProgress, (state, action) => {
        state.currentFileUpload.uploadProgress = action.payload.progress;
        state.currentFileUpload.fileName = action.payload.fileName;
      })
      .addCase(resetUploadProgress, (state, action) => {
        state.currentFileUpload = TranscribeInitialState.currentFileUpload;
      })
      .addCase(resetFilter, (state, action) => {
        state.filterValues = TranscribeInitialState.filterValues;
        state.searchKeyword = TranscribeInitialState.searchKeyword;
      })
      //Download each pack
      .addCase(getDownloadPack.pending, (state, action) => {
        state.getDownloadDataState.fileDownloadLoading = true;
      })
      .addCase(getDownloadPack.fulfilled, (state, action) => {
        state.getDownloadDataState.fileDownloadLoading = false;
      })
      .addCase(getDownloadPack.rejected, (state, action) => {
        state.error = action.error.message;
        state.getDownloadDataState.fileDownloadLoading = false;
      });
  },
});

export default TranscribeSlice.reducer;
